import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track } from "../analytics";

// Tracks a page view on every route change, and (on the home page)
// observes major sections to record which ones are actually viewed.
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    track("pageview");
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname !== "/") return;
    const seen = new Set();
    const ids = ["home", "about", "products", "services", "contact"];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !seen.has(entry.target.id)) {
            seen.add(entry.target.id);
            track("section_view", { label: entry.target.id });
          }
        });
      },
      { threshold: 0.4 }
    );
    // Delay to ensure sections are mounted
    const tid = setTimeout(() => {
      ids.forEach((id) => {
        const el = document.getElementById(id);
        if (el) observer.observe(el);
      });
    }, 800);
    return () => {
      clearTimeout(tid);
      observer.disconnect();
    };
  }, [location.pathname]);

  return null;
}
